import { TimeGranularityOptionValues } from 'pages/EnergyEfficiency/types/energyEfficiency.types';
import { INDICATOR_NAME_VALUES } from 'types/indicators';

export const getGeneratorIdFromIndicatorName = (name: INDICATOR_NAME_VALUES) => {
  switch (name) {
    case INDICATOR_NAME_VALUES.AVG_LOAD_GENERATOR_1:
    case INDICATOR_NAME_VALUES.FUEL_CONSUMPTION_GENERATOR_1:
      return 1;

    case INDICATOR_NAME_VALUES.AVG_LOAD_GENERATOR_2:
    case INDICATOR_NAME_VALUES.FUEL_CONSUMPTION_GENERATOR_2:
      return 2;

    case INDICATOR_NAME_VALUES.AVG_LOAD_GENERATOR_3:
    case INDICATOR_NAME_VALUES.FUEL_CONSUMPTION_GENERATOR_3:
      return 3;

    case INDICATOR_NAME_VALUES.AVG_LOAD_GENERATOR_4:
    case INDICATOR_NAME_VALUES.FUEL_CONSUMPTION_GENERATOR_4:
      return 4;

    case INDICATOR_NAME_VALUES.AVG_LOAD_GENERATOR_5:
    case INDICATOR_NAME_VALUES.FUEL_CONSUMPTION_GENERATOR_5:
      return 5;

    case INDICATOR_NAME_VALUES.AVG_LOAD_GENERATOR_6:
    case INDICATOR_NAME_VALUES.FUEL_CONSUMPTION_GENERATOR_6:
      return 6;

    default:
      return -1;
  }
};

export const getDateFormatFromGranularity = (
  timeGranularity: TimeGranularityOptionValues,
  extended = false,
) => {
  const dateFormat = 'dd/MM/yyyy';
  const extendedDateFormat = 'LLL. do, yyyy';
  const monthFormat = 'MMM yyyy';
  const extendedMonthFormat = 'MMMM yyyy';
  const dateTimeFormat = 'dd/MM/yyyy HH:00';

  switch (timeGranularity) {
    case TimeGranularityOptionValues.MONTHLY:
      return extended ? extendedMonthFormat : monthFormat;
    case TimeGranularityOptionValues.DAILY:
      return extended ? extendedDateFormat : dateFormat;
    case TimeGranularityOptionValues.HOURLY:
      return dateTimeFormat;
  }
};

export const formatSnakeCaseToRawCaps = (snakeCased: string) =>
  snakeCased.replaceAll('_', ' ').toUpperCase();
